
import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import TopCoinBanyUnit from '../../components/TopCoinBanyUnit/TopCoinBanyUnit';

const TopCoinUKBanyUnit = (props) => {

    return (
        <Fragment>
            <div className='index_ico page_wrapper'>
                <Header />
                <main className="page_content">
                    {/* <PageTitle pageTitle={'TOPCOIN MINI TOPCOIN (M.T)'} pagesub={'Home'} /> */}
                    <PageTitle pageTitle={'MINI TOPCOIN (M.T)'} pagesub={'Home'} />
                    <TopCoinBanyUnit/>          
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default  TopCoinUKBanyUnit;